module.exports = __webpack_public_path__ + "static/media/full.85f85aef.jpg";